// extracted by mini-css-extract-plugin
export var copyIcon = "_yl-2";
export var discountCard = "_yl-0";
export var discountCode = "_yl-3";
export var discountContent = "_yl-1";
export var loadingCard = "_yl-4";